import { useDispatch, useSelector } from "react-redux";
import {
  selectCurrentStepIndex,
  selectCurrentSubstepIndex,
  setCurrentStepIndex,
  setCurrentSubstepIndex,
  setAdjustSumInsuredFlowType,
  selectAdjustSumInsuredFlowType,
} from "../redux/features/motorInsuranceAdjustSumInsuredFlowSlice";
import {
  ADJUST_SUM_INSURED_FLOW,
  ADJUST_SUM_INSURED_FLOW_ADJUST_VALUE,
  ADJUST_SUM_INSURED_FLOW_REVIEW_AND_CONFIRM,
} from "../pages/motorInsurancePages/adjustSumInsuredFlow/data";
import { CHANGE_PLAN_UPLOAD_PHOTOS_OF_CAR } from "../pages/motorInsurancePages/changePlanMotorPolicy/data";

const useAdjustSumInsuredFlow = () => {
  const dispatch = useDispatch();
  const flowType = useSelector(selectAdjustSumInsuredFlowType);
  const currentStepIndex = useSelector((state) =>
    selectCurrentStepIndex(state)
  );
  const currentSubstepIndex = useSelector((state) =>
    selectCurrentSubstepIndex(state)
  );

  const steps = motor_insurance_adjust_sum_insured_flow[flowType] || [];
  const currentStep = steps[currentStepIndex] || {};
  const currentSubstep = currentStep.substeps
    ? currentStep.substeps[currentSubstepIndex]
    : "";

  const handleFlowChange = (type, currentStepIndex, currentSubstepIndex) => {
    dispatch(
      setAdjustSumInsuredFlowType({
        type,
        currentStepIndex,
        currentSubstepIndex,
      })
    );
  };

  const handleNextSubstep = () => {
    if (
      currentStep.substeps &&
      currentSubstepIndex < currentStep.substeps.length - 1
    ) {
      dispatch(setCurrentSubstepIndex(currentSubstepIndex + 1));
    } else if (currentSubstepIndex == currentStep.substeps.length - 1) {
      handleNextStep();
    }
  };

  const handlePrevSubstep = () => {
    if (currentSubstepIndex > 0) {
      dispatch(setCurrentSubstepIndex(currentSubstepIndex - 1));
    } else {
      handlePrevStep();
    }
  };

  const handleNextStep = () => {
    if (currentStepIndex < steps.length - 1) {
      dispatch(setCurrentStepIndex(currentStepIndex + 1));
    }
  };

  const handlePrevStep = () => {
    if (currentStepIndex > 0) {
      const currentStep = steps[currentStepIndex - 1] || {};
      const substepIndex = currentStep?.substeps?.length - 1;
      dispatch(setCurrentStepIndex(currentStepIndex - 1));
      dispatch(setCurrentSubstepIndex(substepIndex));
    }
  };

  return {
    handleFlowChange,
    handleNextSubstep,
    handlePrevSubstep,
    handleNextStep,
    handlePrevStep,
    flowType,
    steps,
    currentStep,
    currentStepIndex,
    currentSubstep,
    currentSubstepIndex,
  };
};
export default useAdjustSumInsuredFlow;

export const motor_insurance_adjust_sum_insured_flow = {
  [ADJUST_SUM_INSURED_FLOW]: [
    {
      name: ADJUST_SUM_INSURED_FLOW_ADJUST_VALUE,
      substeps: [ADJUST_SUM_INSURED_FLOW_ADJUST_VALUE],
    },
    {
      name: CHANGE_PLAN_UPLOAD_PHOTOS_OF_CAR,
      substeps: [CHANGE_PLAN_UPLOAD_PHOTOS_OF_CAR],
    },
    {
      name: ADJUST_SUM_INSURED_FLOW_REVIEW_AND_CONFIRM,
      substeps: [ADJUST_SUM_INSURED_FLOW_REVIEW_AND_CONFIRM],
    },
  ],
};
